module.exports = __webpack_public_path__ + "static/KC4-80dfd57fee1bfbc9d08956991b19c03f.png";